import React from 'react';
import { IContent } from '../../../types';
import { withContent } from '../../../hoc/withContext';
import './ComparisonTableBlock.scss';

// @ts-ignore
import Reveal from "react-reveal/Reveal";
import { sendEvent } from "../../../utils";
import CONFIG from "../../../config";

import Filter from "../../Elements/Filter/Filter";
import Title from "../../Elements/Title/Title";
import ComparisonTable from "../../Elements/ComparisonTable/ComparisonTable";

interface IComparisonTableBlockProps {
  context?: IContent;
}

const ComparisonTableBlock = ({ context }: IComparisonTableBlockProps) => {
  const { comparison_table } = context;
  return (
    <Reveal onReveal={() => sendEvent("compare editions - tab displayed - scroll")}>
      <div className="block-comparison-table">
        <div className={`container${CONFIG.isUPC ? " upc" : ""}`}>
          <Title headline={comparison_table.title.headline} baseline={comparison_table.title.baseline} color="#000000" />
          <div className="content">
            <ComparisonTable />
            {!CONFIG.isUPC && (
              <Filter title={comparison_table.select.title} />
            )}
          </div>
        </div>
      </div>
    </Reveal>
  );
};

export default withContent(ComparisonTableBlock);
